const store = {
    'salesInTheLastMonth' : 18748,
    'nameStore' : "Mall 360",
    'logoStore' : "https://http2.mlstatic.com/D_Q_NP_980269-MLA26700254444_012018-G.jpg",
    'oficialStore' : true,
}
export default store